module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp13_9006.51fd399c.png";